import React from 'react';
import { fetchConfig } from '@/hooks/fetch';
import CohortCountsLabelContainer from './CohortCountsLabelContainer';
import CohortCountsLabel from './CohortCountsLabel';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';
import Events from '../hooks/events';

const ClauseCounts = ({
  category,
  code,
  queryUUID,
  clauseUUID,
}) => {
  const state = Selectors.useClauseCounts({
    category, code, queryUUID, clauseUUID,
  });
  const toggleCounts = Events.useToggleClauseCounts(category, { code });
  Fetch.useFetchClauseCounts({
    category, code, queryUUID, clauseUUID,
  }, state.readStatus, fetchConfig([], () => state.allowCohortCounts));

  if (!state.allowCohortCounts) {
    return null;
  }

  return (
    <CohortCountsLabelContainer readStatus={state.readStatus} readErrors={state.readErrors}>
      <CohortCountsLabel
        showCounts={state.showCounts}
        count={state.count}
        total={state.total}
        hideEntities={state.count === 0 || state.entities.length === 0}
        onClick={() => toggleCounts({ queryUUID, clauseUUID })}
      />
    </CohortCountsLabelContainer>
  );
};

export default ClauseCounts;
